/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { ContentEditableEvent } from 'react-contenteditable';
import { IDictionary, IRequestContext } from '../interfaces';
import { EditableField, FieldType } from './editable-fields/editable-field';

export interface ILinksData {
    linkText?: string;
    ariaLabel?: string;
    openInNewTab?: boolean;
    linkUrl?: string;
    className?: string;
    key?: string;
    role?: string;
    additionalProperties?: IDictionary<string>;
    innerClassName?: string;
    linkTag?: string;
    onClick?(ev: React.SyntheticEvent): void;
}

export interface ILinkEditProps {
    requestContext: IRequestContext;

    onTextChange?(index: number): (event: ContentEditableEvent) => void;
}

export interface ILinkProps {
    links: ILinksData[];
    editProps?: ILinkEditProps;
}

/**
 * Component class for action links
 */
export class Links extends React.Component<ILinkProps> {
    constructor(props: ILinkProps) {
        super(props);
    }

    public render = (): JSX.Element | null => {
        if (this.props.links && this.props.links.length > 0) {
            return (
                <>
                    {this.props.links.map((l, i) => (
                        // eslint-disable-next-line react/jsx-key
                        <EditableField
                            requestContext={this.props.editProps?.requestContext}
                            type={FieldType.Link}
                            onChange={
                                this.props.editProps?.onTextChange
                                    ? this.props.editProps.onTextChange(i)
                                    : (event: ContentEditableEvent) => null
                            }
                            fieldProps={{
                                title: l.linkText,
                                text: l.linkText,
                                key: l.key || l.linkUrl,
                                openInNewTab: l.openInNewTab,
                                className: l.className || (i === 0 ? 'msc-cta__primary' : 'msc-cta__secondary'),
                                href: l.linkUrl,
                                role: l.role || 'button',
                                ariaLabel: l.ariaLabel,
                                onClick: l.onClick,
                                additionalProperties: l.additionalProperties,
                                linkTag: l.linkTag,
                                innerClassName: l.innerClassName
                            }}
                        />
                    ))}
                </>
            );
        }
        return null;
    };
}
